// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Popup.css */

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
}

.popup-container {
  position: fixed;
  top: calc(50% - 350px);
  left: calc(50% - 400px); 
  width: 800px;
  height: 700px;
  background-color: #f4f4f9;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  z-index: 2000;
  display: flex;
  flex-direction: column;
}

.drag-handle {
  cursor: move;
  background-color: #ccc;
  padding: 10px;
  margin-bottom: 10px;
  border-radius: 4px;
}

.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.popup-content {
  flex-grow: 1;
}

.popup-label {
  font-size: 1em;
  font-weight: bold;
  color:gray;
  position: absolute;
  top: -20px;
  color:white;
}

.popup-textarea {
  width: 100%;
  height: 18%;
  padding: 10px;
  box-sizing: border-box;
  resize: none;
  font-size: 1em;
}

.popup-button {
  display: block;
  width: 100%;
  margin-top: 10px;
  padding: 10px;
  background: #0056b3;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.editor-container {
  display: flex;
  gap: 20px;
  margin-top: 20px;
  flex-grow: 1;
}

.editor-section {
  width: 50%;
}


/* Additional styles for the new component form */

.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.toggle-form-link {
  font-size: 0.9em;
  color: #007bff;
  cursor: pointer;
  text-decoration: underline;
}

.new-component-section {
}

.new-component-form {
  margin-bottom: 20px;
}

.full-width-input {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
  box-sizing: border-box;
}

.full-width-textarea {
  width: 100%;
  padding: 8px;
  height: 100px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
  box-sizing: border-box;
  resize: none;
}

.full-width-select {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
  box-sizing: border-box;
}

.existing-component-section {
  margin-bottom: 20px;
}

.existing-component label {
  display: block;
  margin-bottom: 5px;
  font-size: 0.9em;
  font-weight: bold;
}

.existing-component select {
  margin-bottom: 15px;
}

.input-row {
  display: flex;
  gap: 20px;
  margin-bottom: 10px;
}

.input-column {
  flex: 1 1;
}


.half-width-input {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1em;
  box-sizing: border-box;
}

.form-sections {
  display: flex;
  flex-direction: column;
  gap: 20px;
}


.popup_tabs {
  display: flex;
  gap: 10px;
  margin-top: 0px;
  width:690px;
}

.popup_tabs a {
  text-decoration: none;
  padding: 10px 15px;
  color: #007bff;
  border-bottom: 2px solid transparent;
}

.popup_tabs a.active {
  font-weight: bold;
  border-bottom: 2px solid #007bff;
}`, "",{"version":3,"sources":["webpack://./src/components/codegen/Popup.css"],"names":[],"mappings":"AAAA,cAAc;;AAEd;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;;AAGA,iDAAiD;;AAEjD;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;AACA;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;AACT;;;AAGA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;;AAGA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,gCAAgC;AAClC","sourcesContent":["/* Popup.css */\r\n\r\n.popup-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5);\r\n  z-index: 1000;\r\n}\r\n\r\n.popup-container {\r\n  position: fixed;\r\n  top: calc(50% - 350px);\r\n  left: calc(50% - 400px); \r\n  width: 800px;\r\n  height: 700px;\r\n  background-color: #f4f4f9;\r\n  padding: 20px;\r\n  border-radius: 8px;\r\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\r\n  z-index: 2000;\r\n  display: flex;\r\n  flex-direction: column;\r\n}\r\n\r\n.drag-handle {\r\n  cursor: move;\r\n  background-color: #ccc;\r\n  padding: 10px;\r\n  margin-bottom: 10px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.close-button {\r\n  position: absolute;\r\n  top: 10px;\r\n  right: 10px;\r\n  cursor: pointer;\r\n}\r\n\r\n.popup-content {\r\n  flex-grow: 1;\r\n}\r\n\r\n.popup-label {\r\n  font-size: 1em;\r\n  font-weight: bold;\r\n  color:gray;\r\n  position: absolute;\r\n  top: -20px;\r\n  color:white;\r\n}\r\n\r\n.popup-textarea {\r\n  width: 100%;\r\n  height: 18%;\r\n  padding: 10px;\r\n  box-sizing: border-box;\r\n  resize: none;\r\n  font-size: 1em;\r\n}\r\n\r\n.popup-button {\r\n  display: block;\r\n  width: 100%;\r\n  margin-top: 10px;\r\n  padding: 10px;\r\n  background: #0056b3;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 4px;\r\n  cursor: pointer;\r\n}\r\n\r\n.editor-container {\r\n  display: flex;\r\n  gap: 20px;\r\n  margin-top: 20px;\r\n  flex-grow: 1;\r\n}\r\n\r\n.editor-section {\r\n  width: 50%;\r\n}\r\n\r\n\r\n/* Additional styles for the new component form */\r\n\r\n.popup-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.toggle-form-link {\r\n  font-size: 0.9em;\r\n  color: #007bff;\r\n  cursor: pointer;\r\n  text-decoration: underline;\r\n}\r\n\r\n.new-component-section {\r\n}\r\n\r\n.new-component-form {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.full-width-input {\r\n  width: 100%;\r\n  padding: 8px;\r\n  margin-bottom: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 1em;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.full-width-textarea {\r\n  width: 100%;\r\n  padding: 8px;\r\n  height: 100px;\r\n  margin-bottom: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 1em;\r\n  box-sizing: border-box;\r\n  resize: none;\r\n}\r\n\r\n.full-width-select {\r\n  width: 100%;\r\n  padding: 8px;\r\n  margin-bottom: 10px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 1em;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.existing-component-section {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.existing-component label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  font-size: 0.9em;\r\n  font-weight: bold;\r\n}\r\n\r\n.existing-component select {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.input-row {\r\n  display: flex;\r\n  gap: 20px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.input-column {\r\n  flex: 1;\r\n}\r\n\r\n\r\n.half-width-input {\r\n  width: 100%;\r\n  padding: 8px;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n  font-size: 1em;\r\n  box-sizing: border-box;\r\n}\r\n\r\n.form-sections {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 20px;\r\n}\r\n\r\n\r\n.popup_tabs {\r\n  display: flex;\r\n  gap: 10px;\r\n  margin-top: 0px;\r\n  width:690px;\r\n}\r\n\r\n.popup_tabs a {\r\n  text-decoration: none;\r\n  padding: 10px 15px;\r\n  color: #007bff;\r\n  border-bottom: 2px solid transparent;\r\n}\r\n\r\n.popup_tabs a.active {\r\n  font-weight: bold;\r\n  border-bottom: 2px solid #007bff;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
